import React from 'react';
import PropTypes from 'prop-types';
import AllhomesLogo from '@domain-group/fe-co-allhomes-logo';
var AppStoreButton = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-pa-allhomes-homepage/static/Appstore@3x_ab7d5f89.png";
var PlayStoreButton = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-pa-allhomes-homepage/static/Playstore@3x_b5603e4f.png";
var PhoneMockUps = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-pa-allhomes-homepage/static/devices_dbc6935e.png";
import * as styles from './app-download.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesAppDownload = props => ___EmotionJSX("div", {
  css: styles.container
}, ___EmotionJSX("div", {
  css: styles.content
}, ___EmotionJSX("div", {
  css: styles.icon
}, ___EmotionJSX(AllhomesLogo, {
  logoType: "h"
})), ___EmotionJSX("div", {
  css: styles.textHeading
}, "We're even better on mobile"), ___EmotionJSX("span", {
  css: styles.text
}, "We love seeing you here, but we can show you an even better time on your mobile. Download the app for a better experience, with more mobile-only features."), ___EmotionJSX("div", {
  css: styles.buttons
}, ___EmotionJSX("a", {
  href: "http://itunes.apple.com/au/app/allhomes.com.au/id499208265",
  onClick: props.onAppStoreClick
}, ___EmotionJSX("img", {
  css: styles.buttonImage,
  src: AppStoreButton,
  alt: "App Store download button"
})), ___EmotionJSX("a", {
  href: "https://play.google.com/store/apps/details?id=au.com.allhomes",
  onClick: props.onGooglePlayClick
}, ___EmotionJSX("img", {
  css: styles.buttonImage,
  src: PlayStoreButton,
  alt: "Google Play download button"
})))), ___EmotionJSX("div", {
  css: styles.illustration
}, ___EmotionJSX("img", {
  css: styles.illustrationPhones,
  src: PhoneMockUps,
  alt: "An Apple and an Android mobile phone, both running the Allhomes app"
})));
AllhomesAppDownload.propTypes = {
  onAppStoreClick: PropTypes.func,
  onGooglePlayClick: PropTypes.func
};
AllhomesAppDownload.defaultProps = {
  onAppStoreClick: () => {},
  onGooglePlayClick: () => {}
};
export default AllhomesAppDownload;